module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/57507ecce9efed03229d8a5b626666a6.png";